import Vue from 'vue'
import commonCode from './packages/code'
import commonButton from './packages/button'
// import commonPaginationV3 from './packages/pagination'
import commonHeaderV3 from './packages/header'
import commonTabsV3 from './packages/tabs'
import commonCarrierSelect from './packages/carriers-select'
import commonImagePicker from './packages/image-picker'
import commonPaginationV3 from './packages/pagination'
import commonPaginationV4 from './packages/pagination2'
import CommonDateWithZone from './packages/dateWithZone'
import commonNewDataPicker from './packages/date-picker'

const componentsV2 = [
  commonCode,
  commonButton,
  commonImagePicker,
  commonPaginationV3,
  commonHeaderV3,
  commonTabsV3,
  commonPaginationV4,
  CommonDateWithZone,
  commonNewDataPicker,
  commonCarrierSelect,
]

componentsV2.forEach((com) => {
  Vue.use(com)
})
